module.exports = __webpack_public_path__ + "img/award-3-min.d744bd59.png";